export default __webpack_public_path__ + "static/media/icon-32-icn-maintenance.1136ab10.svg";